import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class RsvpAnswer extends ModelBase {
  public static readonly type: 'RsvpOpenAnswer' | 'RsvpMultipleChoiceAnswer';
  public readonly type: 'RsvpOpenAnswer' | 'RsvpMultipleChoiceAnswer';

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('rsvp_id')
  public rsvpId: number;

  @autoserializeAs('rsvp_person_id')
  public rsvpPersonId: number;

  @autoserializeAs('rsvp_question_id')
  public rsvpQuestionId: number;
}
